exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-selector .list-group {\n  margin-top: 12px;\n  margin-left: 12px;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  font-size: 14pt;\n}\n\n.list-selector .list-group .list-group-item {\n  padding: 6px 0 !important;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/list-selector/list-selector.css
// module id = 1376
// module chunks = 2